/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom'
import SideNavBar from './Sidebar';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AdminCorporateAdvanceSearch from './AdvancedSearch';
import GlobalContext from '../Context/GloablContext';
import { getAuthItem } from '../../CommonMethods/authSession';

export default function Layout() {
    const auth = useSelector(state => state?.auth);
    const userType = getAuthItem('user_type')
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const [searchParams, setSearchParams]=useSearchParams('')

    // const SideBar = useMemo(() => <SideBar role={userType} />, []);
    return (
        <>
            <div className="flex h-screen overflow-x-hidden">
                <SideNavBar role={userType}/>
                <Outlet />
            </div>
           
        </>
        
    )
}
